export default __webpack_public_path__ + "static/image3-7647afe1b2e4858c9b005525fd52e04f.jpeg";